import CircularSpinner from './CircularSpinner';

export default CircularSpinner;
